import React, { Fragment } from 'react'
import { Helmet } from 'react-helmet'
import { useMemo } from 'sb-hooks'
import { useConnect } from 'sb-redux-hook'
import { string } from 'common/helpers'

import { Box } from 'components/_new/layout'
import Text from 'components/_new/typography/Text/Text'

import BrandsByAlphabet from './BrandsByAlphabet/BrandsByAlphabet'

import messages from './messages'
import s from './Brands.scss'


const groupByAlphabet = (brands, gender) =>
  brands
    .map((brand) => {
      const normalizedName = string.trimChars(brand.name, '(|)')
      const letter = normalizedName.charAt(0).toUpperCase()

      return { letter, ...brand }
    })
    .map(({ letter, name }) => {
      const brand = name.replace(/\s/g, '-').toLowerCase()
      const tail  = gender === 'female' ? '-perfumes' : '-colognes'
      const link  = `/${brand}${tail}`

      return {
        name,
        letter,
        link,
      }
    })
    .sort((a, b) => {
      if (a.letter === b.letter) {
        return a.name < b.name ? -1 : a.name > b.name ? 1 : 0
      }

      return a.letter < b.letter ? -1 : a.letter > b.letter ? 1 : 0
    })
    .reduce((groups, brand) => {
      const { letter, ...link } = brand
      const groupIndex = groups.findIndex(([ matchingLetter ]) => matchingLetter === letter)

      if (groupIndex > -1) {
        groups[groupIndex][1].push(link)
        return groups
      }

      return [ ...groups, [ letter, [ link ] ] ]
    }, [])

const BrandsPage: React.FunctionComponent = () => {
  const { meta, title, description, brands } = useConnect({
    meta: 'view.seoPage.meta',
    title: 'view.seoPage.title',
    brands: 'view.seoPage.brands',
    description: 'view.seoPage.description',
  })

  const sections = useMemo(() => {
    const genders = [ 'female', 'male' ]

    return genders.map((gender) => ({
      title: { ...messages.sectionTitle, values: { gender } },
      items: groupByAlphabet(brands[gender], gender),
    }))
  }, [ brands ])

  return (
    <Fragment>
      <Helmet
        title={meta.title}
        meta={[
          { name: 'description', content: meta.description },
        ]}
      />
      <Text
        message={title}
        size="20-24"
        align="center"
      />
      {
        sections.map(({ title, items }, index) => (
          <Box key={index} mt={36}>
            <Text message={title} size="20-24" color="black" />
            <Box mt={24}>
              <BrandsByAlphabet items={items} />
            </Box>
          </Box>
        ))
      }
      <Box className={s.description} mt={36} pt={36}>
        <Text
          message={description}
          size="12-16"
          color="black"
          html
        />
      </Box>
    </Fragment>
  )
}


export default BrandsPage
